import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=f42c8a38&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=f42c8a38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42c8a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f42c8a38')) {
      api.createRecord('f42c8a38', component.options)
    } else {
      api.reload('f42c8a38', component.options)
    }
    module.hot.accept("./GeneralInfo.vue?vue&type=template&id=f42c8a38&scoped=true", function () {
      api.rerender('f42c8a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/user/components/GeneralInfo.vue"
export default component.exports